import { MESApiService } from "@dexteel/mesf-core";
import { get } from "lodash-es";
import type {
	CurrentCampaignData,
	CurrentCampaignHeader,
	CurrentCampaignStand,
	FutureCampaignsData,
	FutureCampaignHeader,
	FutureCampaignStandDetail,
} from "../models/NextCampaigns";

export const getCurrentCampaign = async ({
	signal,
}: {
	signal?: AbortSignal;
}): Promise<CurrentCampaignData> => {
	const apiService = new MESApiService();
	const resp = await apiService.callV2(
		"[MILL].[GetCurrentCampaign]",
		[],
		signal,
	);

	if (resp.ok) {
		const header = get(
			resp,
			"data.tables[0].rows[0]",
			null,
		) as CurrentCampaignHeader | null;
		const stands = get(
			resp,
			"data.tables[1].rows",
			[],
		) as CurrentCampaignStand[];
		return { header, stands };
	}
	throw new Error(resp.message || "Error fetching current campaign");
};

export const getFutureCampaigns = async ({
	signal,
}: {
	signal?: AbortSignal;
}): Promise<FutureCampaignsData> => {
	const apiService = new MESApiService();
	const resp = await apiService.callV2(
		"[MILL].[GetFutureCampaigns]",
		[],
		signal,
	);

	if (resp.ok) {
		// Table 0 = campaign headers, Table 1 = stand details with ChangeSuggestion
		const headers = get(
			resp,
			"data.tables[0].rows",
			[],
		) as FutureCampaignHeader[];
		const standDetails = get(
			resp,
			"data.tables[1].rows",
			[],
		) as FutureCampaignStandDetail[];
		return { headers, standDetails };
	}
	throw new Error(resp.message || "Error fetching future campaigns");
};
